import React, { Component } from "react";
import ScoreCountCard from "../../components/structure/ScoreCountCard";

class ScoreCountContainer extends Component {
  state = {
    confirmDelete: null,
  };

  handleChange = (event, typeKey) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    let toUpdate = {};
    if (typeKey !== undefined) {
      toUpdate[`scoringTypes.${typeKey}.${event.target.name}`] =
        event.target.value;
    } else {
      toUpdate = newState;
    }
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleSwitch = (e, checked, typeKey) => {
    let newState = {};
    newState[e.target.name] = checked;

    let toUpdate = {};
    if (typeKey !== undefined) {
      toUpdate[`scoringTypes.${typeKey}.${e.target.name}`] = checked;
    } else {
      toUpdate = newState;
    }

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleScoreCalculationTypeChange = (e, typeKey) => {
    e.preventDefault();

    let newState = { scoreCalculationType: e.target.value };

    let toUpdate = {};
    if (typeKey !== undefined) {
      toUpdate[`scoringTypes.${typeKey}.scoreCalculationType`] = e.target.value;
    } else {
      toUpdate = newState;
    }

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleGamePointsChange = (e, result, typeKey) => {
    e.preventDefault();

    const scoreType =
      typeKey === undefined
        ? this.props.tournament
        : (this.props.tournament.scoringTypes || {})[typeKey] || {};

    let gamePoints = scoreType.gamePoints || {};
    if (gamePoints[result] === undefined) {
      gamePoints[result] = {};
    }
    gamePoints[result][e.target.name] = e.target.value;

    let newState = { gamePoints: gamePoints };

    let toUpdate = {};
    if (typeKey !== undefined) {
      toUpdate[`scoringTypes.${typeKey}.gamePoints`] = gamePoints;
    } else {
      toUpdate = newState;
    }

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleAddScoringType = (e) => {
    e.preventDefault();
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const currentScoringTypes = this.props.tournament.scoringTypes || {};
    const scoringTypeKeys = Object.keys(currentScoringTypes).sort(
      (a, b) => a - b
    );
    const scoringTypeId =
      Number(scoringTypeKeys[scoringTypeKeys.length - 1]) + 1 || 0;
    currentScoringTypes[scoringTypeId] = {};
    tournamentRef.update({ scoringTypes: currentScoringTypes });
  };

  handleDeleteScoringType = (e, typeKey) => {
    e.preventDefault();
    if (this.state.confirmDelete !== typeKey) {
      this.setState({ confirmDelete: typeKey });
    } else {
      const db = window.firebase.firestore();
      const tournamentRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);
      const currentScoringTypes = this.props.tournament.scoringTypes || {};
      delete currentScoringTypes[typeKey];
      tournamentRef.update({ scoringTypes: currentScoringTypes });
      this.setState({ confirmDelete: null });
    }
  };

  render() {
    return (
      <ScoreCountCard
        tournament={this.props.tournament}
        handleChange={this.handleChange}
        handleSwitch={this.handleSwitch}
        handleScoreCalculationTypeChange={this.handleScoreCalculationTypeChange}
        handleAddScoringType={this.handleAddScoringType}
        handleDeleteScoringType={this.handleDeleteScoringType}
        handleGamePointsChange={this.handleGamePointsChange}
        confirmDelete={this.state.confirmDelete}
      />
    );
  }
}

export default ScoreCountContainer;
